import {
  customersLabel as customersLabelFor,
  customerLabel as customerLabelFor
} from '@/utils/platformLabels.js'

export default {
  numMerchants(state) {
    return state.numMerchants
  },
  currentMerchant(state) {
    return state.currentMerchant
  },
  isMerchantLoading(state) {
    return state.merchantLoading
  },
  merchantPage(state) {
    return state.merchants
  },
  customerPage(state) {
    return state.customers
  },
  isCustomerLoading(state) {
    return state.customerLoading
  },
  isRecentPaymentLoading(state) {
    return state.recentPaymentLoading
  },
  numCustomers(state) {
    return state.numCustomers
  },
  accountPage(state) {
    return state.accounts
  },
  isAccountLoading(state) {
    return state.accountLoading
  },
  numAccounts(state) {
    return state.numAccounts
  },
  pageTitle(state) {
    return state.pageTitle
  },
  csvData(state) {
    return state.csvData
  },
  currentCustomer(state) {
    return state.currentCustomer
  },
  currentAccount(state) {
    return state.currentAccount
  },
  locations(state) {
    return state.locations
  },
  currentLocation(state) {
    return state.currentLocation
  },
  selectedLocation(state) {
    return state.selectedLocation
  },
  accountTags(state) {
    return state.accountTags
  },
  group(state) {
    return state.group
  },
  users(state) {
    return state.users
  },
  autoResolvableActionsCount(state) {
    return state.failedActions.filter(action => action.is_resolvable).length
  },
  humanResolvableActionsCount(state) {
    return state.failedActions.filter(action => !action.is_resolvable).length
  },
  roleLoading(state) {
    return state.roleLoading
  },
  role(state) {
    return state.role
  },
  dashboardDateRange(state) {
    return state.dashboardDateRange
  },
  isSideNavOpen(state) {
    return state.isSideNavOpen
  },
  isReportsFlyoutOpen(state) {
    return state.isReportsFlyoutOpen
  },
  starredReports(state) {
    return state.starredReports
  },
  uiPreferences(state) {
    return state.uiPreferences
  },
  /**
   * the merchant to address the ui-preference endpoint with. The bucket is keyed by the caller's user id
   * — the merchant in the path is only the gateway's tenant gate — so the token's claim serves just as
   * well and lands a merchant fetch earlier than currentMerchant.
   */
  preferenceMerchantId(state, getters) {
    const pkid = state.currentMerchant?.pkid

    return pkid === undefined || pkid === null
      ? getters.tokenMerchantId || null
      : String(pkid)
  },
  aiBatchConfigs(state) {
    return state.aiBatchConfigs
  },
  aiBatchConfigsCount(state) {
    return state.aiBatchConfigsCount
  },
  isAiBatchConfigsLoading(state) {
    return state.aiBatchConfigsLoading
  },
  aiCallerAgents(state) {
    return state.aiCallerAgents
  },
  isAiCallerAgentsLoading(state) {
    return state.aiCallerAgentsLoading
  },
  aiCallerBatches(state) {
    return state.aiCallerBatches
  },
  aiCallerBatchesCount(state) {
    return state.aiCallerBatchesCount
  },
  isAiCallerBatchesLoading(state) {
    return state.aiCallerBatchesLoading
  },
  customersLabel(state) {
    return customersLabelFor(null, state.currentMerchant)
  },
  customerLabel(state) {
    return customerLabelFor(null, state.currentMerchant)
  }
}
